import React from 'react';
import ReactDOM from 'react-dom/client';
import { RecoilRoot } from 'recoil';
import { ConfigProvider, theme, App } from 'antd';
import { AppRouter } from './router';
import zhCN from 'antd/locale/zh_CN';
import './styles/tailwind.css';
import './styles/custom.less';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  // <React.StrictMode>
  <RecoilRoot>
    <ConfigProvider
      locale={zhCN}
      theme={{
        algorithm: theme.defaultAlgorithm,
        token: {
          colorPrimary: '#1677ff',
          borderRadius: 8,
        },
      }}
    >
      <App>
        <AppRouter />
      </App>
    </ConfigProvider>
  </RecoilRoot>,
  // </React.StrictMode>,
);
